/**
 * 移动端布局外壳：居中约束容器 + 页面内容（各页自带头部）+ 底部 4 Tab 导航。
 * 不再渲染全局 AppBar（头部由各页通过 PageHeader 自行控制，以满足原型差异）。
 *
 * 约束交由 MobileFrame 处理：手机铺满、桌面/平板收成 480 居中卡片。
 */
import MobileFrame from '@/components/mobile/MobileFrame';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import BottomNav from '@/components/mobile/BottomNav';

export default function MobileLayout() {
  return (
    <MobileFrame>
      <Box sx={{ pb: 'calc(76px + env(safe-area-inset-bottom))' }}>
        <Outlet />
      </Box>
      <BottomNav />
    </MobileFrame>
  );
}
